import _objectSpread from "C:\\Users\\PabloGabriel\\Documents\\Reactors\\RepoOrquesta\\orquesta\\consola\\app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
export function withPane(props, context) {
  var _props$pane;

  var pane = (_props$pane = props.pane) !== null && _props$pane !== void 0 ? _props$pane : context.pane;
  return pane ? _objectSpread(_objectSpread({}, props), {}, {
    pane: pane
  }) : props;
}